import { useCallback, useState } from 'react'

import { getOfferBids } from 'legacy/services/offers'

export function useBidHistory() {
  const [history, setHistory] = useState([])

  const fetchBidHistory = useCallback((offerUuid, params) => {
    getOfferBids(offerUuid, params).then(bids => {
      if (!bids.length) return
      setHistory(bids)
    })
  }, [])

  return {
    history,
    fetchBidHistory,
  }
}
